export default __webpack_public_path__ + "static/media/mariaImage.e5327aa4.jpg";